import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import {
  ReskinPopUpHeadingTitle,
  ReskinPopUpHeadingDescription,
} from 'portal-modules/common/components/modals/atoms'
import { Form } from '@entrata/portals-common/lib/components/forms'
import { EmailField, TextField } from '@entrata/portals-common/lib/boxed-fields'
import emailValidator from 'portal-modules/common/utils/email-validator'
import Button from 'portal-modules/common/components/Button'
import {
  StyledFormDiv,
  StyledFormActionDiv,
} from 'portal-modules/auth/components/atoms'
import {
  sendEmailOTP,
  requestSubmitOtp,
} from 'portal-modules/auth/redux/modules/user'
import { CountDownMinutesTimer } from 'portal-modules/auth/components'
import { PageLoader } from 'portal-modules/common/components/loaders'
import { connect } from 'react-redux'
import SystemMessage from 'portal-modules/common/components/SystemMessage'
import RemoveErrorsOnUnmount from 'portal-modules/common/components/RemoveErrorsOnUnmount'

const EmailOtpForm = props => {
  const { userEmail, requestOtp, requestSubmitOtp, error, loading } = props
  const [otpFormState, setOtpFormState] = useState({
    isOtpSend: false,
    userEmail: '',
  })

  let { cid } = window.rpSettings
  const handleSendOtp = ({ values }) => {
    const { username, code } = values
    const payload = {
      username,
      cid,
    }
    if (!otpFormState.isOtpSend) {
      requestOtp({
        payload,
        callback: () => {
          setOtpFormState({
            ...otpFormState,
            userEmail: username,
            isOtpSend: true,
          })
        },
      })
    } else {
      code &&
        requestSubmitOtp({
          payload: { username, otp_code: code, push: props.history.push },
        })
    }
  }

  const initialFieldState = {
    username: {
      required: !otpFormState.isOtpSend,
      value: userEmail,
    },
    code: {
      value: '',
    },
  }

  return (
    <RemoveErrorsOnUnmount errorKey='otpLogin'>
      <ReskinPopUpHeadingTitle
        customMargin='40px 48px 7px 46px'
        mediaMargin='40px 48px 7px 46px'
      >
        {!otpFormState.isOtpSend
          ? __('Enter Your Resident Portal Email Address')
          : __('Enter Code')}
      </ReskinPopUpHeadingTitle>
      <ReskinPopUpHeadingDescription
        customMargin='0 48px 16px 48px'
        mediaMargin='0 48px 16px 48px'
      >
        {!otpFormState.isOtpSend
          ? __(
              "We'll send you a single use code that you can use to log into your account.",
            )
          : __(
              'If the email is in our system, we will send a single-use password to your',
            )}
        {otpFormState.isOtpSend && (
          <b>&nbsp;&nbsp;{otpFormState.userEmail}&nbsp;&nbsp;</b>
        )}
        {otpFormState.isOtpSend &&
          __(
            'address. Enter the code from the email below. If you don’t receive the email, please check your spam folder, or try a different email address.',
          )}
        <br />
        <br />
        {otpFormState.isOtpSend && (
          <>
            {__('Code expires in: ')} <CountDownMinutesTimer minutes={30} />
          </>
        )}
      </ReskinPopUpHeadingDescription>
      {typeof error === 'string' && error ? (
        <SystemMessage shouldScrollOnMount type='error'>
          {error}
        </SystemMessage>
      ) : (
        <></>
      )}

      <StyledFormDiv>
        <Form
          {...props}
          onSubmit={handleSendOtp}
          initialFieldState={initialFieldState}
        >
          {!otpFormState.isOtpSend ? (
            <Form.Field name='username'>
              {fieldProps => (
                <EmailField
                  {...fieldProps}
                  validate={emailValidator}
                  id='username'
                  label={__('Email')}
                />
              )}
            </Form.Field>
          ) : (
            <Form.Spy
              field={['username']}
              render={() => (
                <Form.Field name='code'>
                  {fieldProps => (
                    <TextField
                      {...fieldProps}
                      label={__('Code')}
                      required={otpFormState.isOtpSend}
                    />
                  )}
                </Form.Field>
              )}
            />
          )}

          <Form.Actions
            render={({ values: { username, code } }) => (
              <StyledFormActionDiv>
                <Button
                  size='medium'
                  disabled={
                    (!otpFormState.isOtpSend && !username) ||
                    (otpFormState.isOtpSend && username && !code)
                  }
                  appearance='primary'
                  type='submit'
                >
                  {!otpFormState.isOtpSend ? __('Send Code') : __('Submit')}
                </Button>
                <Button
                  size='medium'
                  onClick={props.onClose}
                  appearance='secondary'
                  type='button'
                >
                  {__('Cancel')}
                </Button>
              </StyledFormActionDiv>
            )}
          />
        </Form>
        <PageLoader message={loading} show={!!loading} />
      </StyledFormDiv>
    </RemoveErrorsOnUnmount>
  )
}

EmailOtpForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  userEmail: PropTypes.string,
  error: PropTypes.string,
  loading: PropTypes.string,
  requestOtp: PropTypes.func,
  requestSubmitOtp: PropTypes.func,
  history: PropTypes.object,
}

export default connect(
  ({ errors, user, loading }) => ({
    error: errors?.otpLogin || '',
    lockedOut: !!user.lockoutUntil,
    loading: loading?.otpLogin?.message || '',
  }),
  { requestOtp: sendEmailOTP, requestSubmitOtp },
)(EmailOtpForm)
